<template>
  <div>
    <!-- 标题 -->
    <div class="Instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticComputeCloudMonitor">{{
          $t("alarms.instance.instance")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="Instance-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" filterable @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAWS">
          <Select v-model="cycle" filterable @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6" v-show="isALY">
          <Select v-model="timeType" filterable @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAzure">
          <Select v-model="timeType" filterable @on-change="changeTimeTypeAzure(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isVMware">
          <Select
            v-model="timeType"
            @on-change="changeTimeTypeVmware(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isGCP">
          <Select v-model="timeType" @on-change="changeTimeTypeGCP(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isGCP">
          <Select v-model="cycle" @on-change="changeCycleGCP()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : this.$route.query.accountTypeName == 'Azure'
          ? azureList
          : this.$route.query.accountTypeName == 'GCP'
          ? gcpList
          : vmwareList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "Instance",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // aws折线图
      awsList: [
        {
          id: "cpus",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizations",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "cpudiskSpaceUtilizations",
          title: this.$t("alarms.instance.line.DiskUtilizationPercent")
        },
        {
          id: "DiskReadAndWrite",
          title: this.$t("alarms.instance.line.DiskReadAndWriteBytes")
        },
        {
          id: "DiskReadAndWriteOperations",
          title: this.$t(
            "alarms.instance.line.ReadAndWriteDiskOperationsOperations"
          )
        },
        {
          id: "NetworkInputAndOutput",
          title: this.$t("alarms.instance.line.NetworkInputAndOutputBytes")
        },
        {
          id: "NetworkPacketIncomingAndOutgoing",
          title: this.$t(
            "alarms.instance.line.IncomingAndOutgoingNetworkPacketsNumber"
          )
        },
        {
          id: "StatusCheckFailedRandomly",
          title: this.$t(
            "alarms.instance.line.StatusCheckFailedArbitraryQuantity"
          )
        },
        {
          id: "StatusCheckFailedInstance",
          title: this.$t(
            "alarms.instance.line.StatusCheckFailedInstanceQuantity"
          )
        },
        {
          id: "StatusCheckFailureSystem",
          title: this.$t("alarms.instance.line.StatusCheckFailedSystemQuantity")
        },
        {
          id: "CpuQuotaUsage",
          title: this.$t("alarms.instance.line.CPUQuotaUsageQuantity")
        },
        {
          id: "CpuQuotaBalance",
          title: this.$t("alarms.instance.line.CPUQuotaBalanceQuantity")
        },
        {
          id: "linuxInodeUtilizations",
          title: this.$t("alarms.instance.line.LinuxInodeUtilizationPercentage")
        }
      ],
      // 阿里云折线图
      alyList: [
        {
          id: "cpuUtilization",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizationALYs",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "diskSpaceUtilization",
          title: this.$t("alarms.instance.line.DiskSpaceUsagePercentage")
        },
        {
          id: "networkIncomingBandwidth",
          title: this.$t("alarms.instance.line.NetworkIncomingBandwidthBit")
        },
        {
          id: "networkOutboundBandwidth",
          title: this.$t("alarms.instance.line.NetworkOutgoingBandwidthBit")
        },
        {
          id: "diskAverageBPS",
          title: this.$t("alarms.instance.line.AverageDiskBPSBps")
        },
        {
          id: "diskAverageIOPS",
          title: this.$t("alarms.instance.line.DiskAverageIOPSTimesSec")
        },
        {
          id: "vpcPublicIpInternetOutRatePercent",
          title: this.$t(
            "alarms.instance.line.VpcPublicIpInternetOutRatePercent"
          ),
          id: "cpuTotal",
          title: this.$t("alarms.instance.line.TotalCPUCurrentlyPercent")
        },
        {
          id: "netWorkPackage",
          title: this.$t("alarms.instance.line.NetWorkPackage")
        },
        {
          id: "tcpConnection",
          title: this.$t("alarms.instance.line.TcpConnection")
        },
        {
          id: "averageSystemLoad",
          title: this.$t("alarms.instance.line.AverageSystemLoad")
        },
        {
          id: "networkRate",
          title: this.$t("alarms.instance.line.NetworkRate")
        },
        {
          id: "vpcPublicIpInternetOutRatePercent",
          title: this.$t(
            "alarms.instance.line.VpcPublicIpInternetOutRatePercent"
          )
        }
      ],
      // azure折线图
      azureList: [
        {
          id: "cpuUtilizationAzure",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizationAzure",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "diskSpaceUtilizationAzure",
          title: this.$t("alarms.instance.line.DiskUtilizationPercent")
        },
        {
          id: "networkInputAndOutputsAzure",
          title: this.$t("alarms.instance.line.NetworkInputAndOutputBytes")
        }
      ],
      // vmware折线图
      vmwareList: [
        {
          id: "cpuUtilizationVmware",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizationVmware",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "diskSpaceUtilizationVmware",
          title: this.$t("alarms.instance.line.DiskUtilizationPercent")
        }
      ],
      // gcp折线图
      gcpList: [
        {
          id: "cpuUtilizationGCP",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizationGCP",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "upTime",
          title: this.$t("alarms.instance.line.UpTime")
        },
        {
          id: "systemUpTime",
          title: this.$t("alarms.instance.line.SystemUpTime")
        },
        {
          id: "networkInputAndOutputsGCP",
          title: this.$t("alarms.instance.line.NetworkInputAndOutputBytes")
        },
        {
          id: "cpuUsageTime",
          title: this.$t("alarms.instance.line.CpuUsageTimeSecond")
        },
        {
          id: "diskReadBytesCount",
          title: this.$t("alarms.instance.line.DiskReadBytesCountKiBS")
        },
        {
          id: "diskWriteBytesCount",
          title: this.$t("alarms.instance.line.DiskWriteBytesCountKIBs")
        },
        {
          id: "diskMaxWriteOpsCount",
          title: this.$t("alarms.instance.line.DiskMaxWriteOpsCount")
        },
        {
          id: "diskMaxReadOpsCount",
          title: this.$t("alarms.instance.line.DiskMaxReadOpsCount")
        },
        {
          id: "diskReadOpsCount",
          title: this.$t("alarms.instance.line.DiskReadOpsCountTimesSec")
        },
        {
          id: "diskPercentUsed",
          title: this.$t("alarms.instance.line.DiskPercentUsedPercentage")
        }
      ],
      isAWS: false,
      isALY: false,
      isAzure: false,
      isVMware: false,
      isGCP: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      instanceId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      privateIp: "",
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60
        }
      ],
      // echarts实例
      chart: "",
      chartDiskReadAndWrite: "",
      chartDiskReadAndWriteOperations: "",
      chartNetworkInputAndOutput: "",
      chartNetworkPacketIncomingAndOutgoing: "",
      chartStatusCheckFailedRandomly: "",
      chartStatusCheckFailedInstance: "",
      chartStatusCheckFailureSystem: "",
      chartCpuQuotaUsage: "",
      chartCpuQuotaBalance: "",
      chartMemoryUtilization: "",
      chartCpuUtilizationAzure: "",
      chartmemoryUtilizationAzure: "",
      chartDiskSpaceUtilizationAzure: "",
      chartNetworkInputAndOutputsAzure: "",
      chartCpuUtilizationVmware: "",
      chartMemoryUtilizationVmware: "",
      chartDiskSpaceUtilizationVmware: "",
      chartCpuUtilizationGCP: "",
      chartUpTime: "",
      chartSystemUpTime: "",
      chartmemoryUtilizationGCP: "",
      chartNetworkInputAndOutputsGCP: "",
      chartCpuUsageTime: "",
      chartDiskReadBytesCount: "",
      chartDiskWriteBytesCount: "",
      chartDiskMaxWriteOpsCount: "",
      chartDiskMaxReadOpsCount: "",
      chartDiskReadOpsCount: "",
      chartDiskPercentUsed: "",
      chartpusOption: {},
      memoryUtilizationsOption: {},
      cpudiskSpaceUtilizationsOption: {},
      DiskReadAndWriteOption: {},
      DiskReadAndWriteOperationsOption: {},
      NetworkInputAndOutputOption: {},
      NetworkPacketIncomingAndOutgoingOption: {},
      StatusCheckFailedRandomlyOption: {},
      StatusCheckFailedInstanceOption: {},
      StatusCheckFailureSystemOption: {},
      CpuQuotaUsageOption: {},
      CpuQuotaBalanceOption: {},
      linuxInodeUtilizationsOption: {}, //aws
      cpuUtilizationOption: {},
      memoryUtilizationALYsOption: {},
      diskSpaceUtilizationOption: {},
      networkIncomingBandwidthOption: {},
      networkOutboundBandwidthOption: {},
      diskAverageBPSOption: {},
      diskAverageIOPSOption: {},
      vpcPublicIpInternetOutRatePercentOptions: {}, //阿里云
      cpuTotalOption: {},
      netWorkPackageOption: {},
      tcpConnectionOption: {},
      netWorkRateOption: {}, //阿里云
      cpuUtilizationAzureOption: {},
      memoryUtilizationAzureOption: {},
      diskSpaceUtilizationAzureOption: {},
      networkInputAndOutputsAzureOption: {}, //azure
      cpuUtilizationVmwareOption: {},
      memoryUtilizationVmwareOption: {},
      diskSpaceUtilizationVmwareOption: {}, //vmware
      cpuUtilizationGCPOption: {},
      upTimeOption: {},
      systemUpTimeOption: {},
      memoryUtilizationGCPOption: {},
      networkInputAndOutputsGCPOption: {},
      cpuUsageTimeOption: {},
      diskReadBytesCountOption: {},
      diskWriteBytesCountOption: {},
      diskMaxWriteOpsCountOption: {},
      diskMaxReadOpsCountOption: {},
      diskReadOpsCountOption: {},
      diskPercentUsedOption: {}, //gcp
      // AWS数组
      cpuUtilizations: [],
      diskReadBytes: [],
      diskWriteBytes: [],
      diskReadOps: [],
      diskWriteOps: [],
      networkInput: [],
      networkOutput: [],
      networkPacketsIn: [],
      networkPacketsOut: [],
      statusCheckFailed: [],
      statusCheckFailedInstance: [],
      statusCheckFailedSystem: [],
      cpudiskSpaceUtilization: [],
      cpudiskSpaceUtilizationList: [],
      chartCpudiskSpaceUtilization: "",
      linuxInodeUtilization: [],
      linuxInodeUtilizationList: [],
      chartLinuxInodeUtilization: "",
      xaxisData: [],
      linuxInodeXaxisData: [],
      //阿里云数组
      cpuUtilization: [],
      memoryUtilization: [],
      diskSpaceUtilization: [],
      memoryUtilizationALY: [],
      chartDiskSpaceUtilization: "",
      chartCpuUtilization: "",
      xaxisDataShort: [],
      internetInRate: [],
      intranetInRate: [],
      internetOutRate: [],
      intranetOutRate: [],
      diskReadBPSNew: [],
      diskWriteBPSNew: [],
      diskReadIOPS: [],
      diskWriteIOPS: [],
      vpcPublicIpInternetOutRatePercent: [],
      chartmemoryUtilizationALYs: "",
      chartNetworkIncomingBandwidth: "",
      chartNetworkOutboundBandwidth: "",
      chartDiskAverageBPS: "",
      chartDiskAverageIOPS: "",
      chartVpcPublicIpInternetOutRatePercent: "",
      cpuTotal: [],
      netWorkPackage: [],
      networkinPackages: [],
      networkoutPackages: [],
      tcpConnection: [],
      ESTABLISHED: [],
      NON_ESTABLISHED: [],
      TCP_TOTAL: [],
      averageSystemLoad: [],
      load1m: [],
      load5m: [],
      load15m: [],
      networkRate: [],
      networkinRate: [],
      networkoutRate: [],
      chartmemoryUtilizationALYs: "",
      chartNetworkIncomingBandwidth: "",
      chartNetworkOutboundBandwidth: "",
      chartCpuTotal: "",
      chartNetWorkPackage: "",
      chartDiskAverageBPS: "",
      chartDiskAverageIOPS: "",
      chartTcpConnection: "",
      chartAverageSystemLoad: "",
      chartNetworkRate: "",
      //Azure数组
      azureCpuUsage: [],
      azureNetworkIn: [],
      azureNetworkOut: [],
      azureTimeline: [],
      azureMemoryAndStorageXAxes: [],
      azureMemoryPercent: [],
      azureStoragePercent: [],
      //Vmware数组
      vmWareTimeline: [],
      vmWareDiskSpaceUsage: [],
      vmWareMemoryUsage: [],
      vmWareCpuUsage: [],
      //GCP数组
      gcpTimeline: [],
      gcpCpuUsage: [],
      upTime: [],
      systemUpTime: [],
      gcpMemoryPercent: [],
      gcpNetworkIn: [],
      gcpNetworkOut: [],
      cpuUsageTime: [],
      diskReadBytesCount: [],
      diskWriteBytesCount: [],
      diskMaxWriteOpsCount: [],
      diskMaxReadOpsCount: [],
      diskReadOpsCount: [],
      diskPercentUsed: [],
      arr: []
    };
  },
  mounted: function() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chart.resize();
        self.chartMemoryUtilization.resize();
        self.chartCpudiskSpaceUtilization.resize();
        self.chartLinuxInodeUtilization.resize();
        self.chartDiskReadAndWrite.resize();
        self.chartDiskReadAndWriteOperations.resize();
        self.chartNetworkInputAndOutput.resize();
        self.chartNetworkPacketIncomingAndOutgoing.resize();
        self.chartStatusCheckFailedRandomly.resize();
        self.chartStatusCheckFailedInstance.resize();
        self.chartStatusCheckFailureSystem.resize();
        self.chartCpuQuotaUsage.resize();
        self.chartCpuQuotaBalance.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartCpuUtilization.resize();
        self.chartmemoryUtilizationALYs.resize();
        self.chartNetworkIncomingBandwidth.resize();
        self.chartNetworkOutboundBandwidth.resize();
        self.chartDiskAverageBPS.resize();
        self.chartDiskAverageIOPS.resize();
        self.chartDiskSpaceUtilization.resize();
        self.chartVpcPublicIpInternetOutRatePercent.resize();
        self.chartCpuTotal.resize();
        self.chartNetWorkPackage.resize();
        self.chartTcpConnection.resize();
        self.chartAverageSystemLoad.resize();
        this.chartNetworkRate.resize();
      });
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartCpuUtilizationAzure.resize();
        self.chartmemoryUtilizationAzure.resize();
        self.chartDiskSpaceUtilizationAzure.resize();
        self.chartNetworkInputAndOutputsAzure.resize();
      });
    } else if (this.$route.query.accountTypeName == "VMware") {
      this.isVMware = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartCpuUtilizationVmware.resize();
        self.chartMemoryUtilizationVmware.resize();
        self.chartDiskSpaceUtilizationVmware.resize();
      });
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartCpuUtilizationGCP.resize();
        self.chartUpTime.resize();
        self.chartSystemUpTime.resize();
        self.chartMemoryUtilizationGCP.resize();
        self.chartNetworkInputAndOutputsGCP.resize();
        self.chartCpuUsageTime.resize();
        self.chartDiskReadBytesCount.resize();
        self.chartDiskWriteBytesCount.resize();
        self.chartDiskMaxWriteOpsCount.resize();
        self.chartDiskMaxReadOpsCount.resize();
        self.chartDiskReadOpsCount.resize();
        self.chartDiskPercentUsed.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.checkALIECSIndex();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.checkAzureVmIndex();
    } else if (this.$route.query.accountTypeName == "VMware") {
      this.isVMware = true;
      this.checkVmwareMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.checkGcpVmIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function(item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // AWS
          if (item.id == "cpus") {
            var optionFll = this.cpusOption;
          } else if (item.id == "memoryUtilizations") {
            var optionFll = this.memoryUtilizationsOption;
          } else if (item.id == "cpudiskSpaceUtilizations") {
            var optionFll = this.cpudiskSpaceUtilizationsOption;
          } else if (item.id == "DiskReadAndWrite") {
            var optionFll = this.DiskReadAndWriteOption;
          } else if (item.id == "DiskReadAndWriteOperations") {
            var optionFll = this.DiskReadAndWriteOperationsOption;
          } else if (item.id == "NetworkInputAndOutput") {
            var optionFll = this.NetworkInputAndOutputOption;
          } else if (item.id == "NetworkPacketIncomingAndOutgoing") {
            var optionFll = this.NetworkPacketIncomingAndOutgoingOption;
          } else if (item.id == "StatusCheckFailedRandomly") {
            var optionFll = this.StatusCheckFailedRandomlyOption;
          } else if (item.id == "StatusCheckFailedInstance") {
            var optionFll = this.StatusCheckFailedInstanceOption;
          } else if (item.id == "StatusCheckFailureSystem") {
            var optionFll = this.StatusCheckFailureSystemOption;
          } else if (item.id == "CpuQuotaUsage") {
            var optionFll = this.CpuQuotaUsageOption;
          } else if (item.id == "CpuQuotaBalance") {
            var optionFll = this.CpuQuotaBalanceOption;
          } else if (item.id == "linuxInodeUtilizations") {
            var optionFll = this.linuxInodeUtilizationsOption;
          }
          // 阿里云
          else if (item.id == "cpuUtilization") {
            var optionFll = this.cpuUtilizationOption;
          } else if (item.id == "memoryUtilizationALYs") {
            var optionFll = this.memoryUtilizationALYsOption;
          } else if (item.id == "diskSpaceUtilization") {
            var optionFll = this.diskSpaceUtilizationOption;
          } else if (item.id == "networkIncomingBandwidth") {
            var optionFll = this.networkIncomingBandwidthOption;
          } else if (item.id == "networkOutboundBandwidth") {
            var optionFll = this.networkOutboundBandwidthOption;
          } else if (item.id == "diskAverageBPS") {
            var optionFll = this.diskAverageBPSOption;
          } else if (item.id == "diskAverageIOPS") {
            var optionFll = this.diskAverageIOPSOption;
          } else if (item.id == "vpcPublicIpInternetOutRatePercent") {
            var optionFll = this.vpcPublicIpInternetOutRatePercentOption;
          } else if (item.id == "cpuTotal") {
            var optionFll = this.cpuTotalOption;
          } else if (item.id == "netWorkPackage") {
            var optionFll = this.netWorkPackageOption;
          } else if (item.id == "tcpConnection") {
            var optionFll = this.tcpConnectionOption;
          } else if (item.id == "averageSystemLoad") {
            var optionFll = this.averageSystemLoadOption;
          } else if (item.id == "networkRate") {
            var optionFll = this.netWorkRateOption;
          }

          // azure
          else if (item.id == "cpuUtilizationAzure") {
            var optionFll = this.cpuUtilizationAzureOption;
          } else if (item.id == "memoryUtilizationAzure") {
            var optionFll = this.memoryUtilizationAzureOption;
          } else if (item.id == "diskSpaceUtilizationAzure") {
            var optionFll = this.diskSpaceUtilizationAzureOption;
          } else if (item.id == "networkInputAndOutputsAzure") {
            var optionFll = this.networkInputAndOutputsAzureOption;
          }
          // vmware
          else if (item.id == "cpuUtilizationVmware") {
            var optionFll = this.cpuUtilizationVmwareOption;
          } else if (item.id == "memoryUtilizationVmware") {
            var optionFll = this.memoryUtilizationVmwareOption;
          } else if (item.id == "diskSpaceUtilizationVmware") {
            var optionFll = this.diskSpaceUtilizationVmwareOption;
          }
          // gcp
          else if (item.id == "cpuUtilizationGCP") {
            var optionFll = this.cpuUtilizationGCPOption;
          } else if (item.id == "memoryUtilizationGCP") {
            var optionFll = this.memoryUtilizationGCPOption;
          } else if (item.id == "networkInputAndOutputsGCP") {
            var optionFll = this.networkInputAndOutputsGCPOption;
          } else if (item.id == "cpuUsageTime") {
            var optionFll = this.cpuUsageTimeOption;
          } else if (item.id == "diskReadBytesCount") {
            var optionFll = this.diskReadBytesCountOption;
          } else if (item.id == "diskWriteBytesCount") {
            var optionFll = this.diskWriteBytesCountOption;
          } else if (item.id == "diskMaxWriteOpsCount") {
            var optionFll = this.diskMaxWriteOpsCountOption;
          } else if (item.id == "diskMaxReadOpsCount") {
            var optionFll = this.diskMaxReadOpsCountOption;
          } else if (item.id == "diskReadOpsCount") {
            var optionFll = this.diskReadOpsCountOption;
          } else if (item.id == "diskPercentUsed") {
            var optionFll = this.diskPercentUsedOption;
          } else if (item.id == "upTime") {
            var optionFll = this.upTimeOption;
          } else if (item.id == "systemUpTime") {
            var optionFll = this.systemUpTimeOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function() {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function() {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        });
    },
    // AWS折线图
    checkMonitorModuleIndex: function() {
      this.$api.cloudWatch
        .checkMonitorModuleIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region
        })
        .then(res => {
          this.cpuUtilizations = res.data.cpuUtilizations;
          this.diskReadBytes = res.data.diskReadBytes;
          this.diskWriteBytes = res.data.diskWriteBytes;
          this.diskReadOps = res.data.diskReadOps;
          this.diskWriteOps = res.data.diskWriteOps;
          this.networkInput = res.data.networkInput;
          this.networkOutput = res.data.networkOutput;
          this.networkPacketsIn = res.data.networkPacketsIn;
          this.networkPacketsOut = res.data.networkPacketsOut;
          this.statusCheckFailed = res.data.statusCheckFailed;
          this.statusCheckFailedInstance = res.data.statusCheckFailedInstance;
          this.statusCheckFailedSystem = res.data.statusCheckFailedSystem;
          this.cpucreditUsage = res.data.cpucreditUsage;
          this.cpucreditBalance = res.data.cpucreditBalance;
          this.memoryUtilization = res.data.memoryUtilization;
          // 多磁盘
          this.cpudiskSpaceUtilization = res.data.cpudiskSpaceUtilization;
          if (this.cpudiskSpaceUtilization == undefined) {
            return;
          }
          this.cpudiskSpaceUtilizationList = [];
          for (var i = 0; i < this.cpudiskSpaceUtilization.length; i++) {
            var CpudiskSpaceUtilizationCopy = new Object();
            CpudiskSpaceUtilizationCopy.name = this.cpudiskSpaceUtilization[
              i
            ].name;
            this.cpudiskSpaceUtilizationList.push(CpudiskSpaceUtilizationCopy);
          }
          // Inode Mounteds
          this.linuxInodeUtilization = res.data.linuxInodeUtilization;
          if (this.linuxInodeUtilization == undefined) {
            return;
          }
          this.linuxInodeUtilizationList = [];
          for (var i = 0; i < this.linuxInodeUtilization.length; i++) {
            var linuxInodeUtilizationCopy = new Object();
            linuxInodeUtilizationCopy.name = this.linuxInodeUtilization[i].name;
            this.linuxInodeUtilizationList.push(linuxInodeUtilizationCopy);
          }
          this.xaxisData = res.data.xaxisData;
          this.linuxInodeXaxisData = res.data.linuxInodeXaxisData;
          this.init();
        });
    },
    // 阿里云折线图
    checkALIECSIndex: function() {
      this.$api.cloudWatch
        .checkALIECSIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region
        })
        .then(res => {
          this.cpuUtilization = res.data.cpuUtilization;
          this.memoryUtilizationALY = res.data.memoryUtilization;
          this.diskSpaceUtilization = res.data.diskSpaceUtilization;
          this.internetInRate = res.data.internetInRate;
          this.intranetInRate = res.data.intranetInRate;
          this.internetOutRate = res.data.internetOutRate;
          this.intranetOutRate = res.data.intranetOutRate;
          this.diskReadBPSNew = res.data.diskReadBPSNew;
          this.diskWriteBPSNew = res.data.diskWriteBPSNew;
          this.diskReadIOPS = res.data.diskReadIOPS;
          this.diskWriteIOPS = res.data.diskWriteIOPS;
          this.vpcPublicIpInternetOutRatePercent =
            res.data.vpcPublicIpInternetOutRatePercent;
          this.cpuTotal = res.data.cpuTotal;
          this.netWorkPackage = res.data.netWorkPackage;
          this.networkinPackages = res.data.networkinPackages;
          this.networkoutPackages = res.data.networkoutPackages;
          this.tcpConnection = res.data.tcpConnection;
          this.ESTABLISHED = res.data.tcpConnection.ESTABLISHED;
          this.NON_ESTABLISHED = res.data.tcpConnection.NON_ESTABLISHED;
          this.TCP_TOTAL = res.data.tcpConnection.TCP_TOTAL;
          this.averageSystemLoad = res.data.averageSystemLoad;
          this.load1m = res.data.load1m;
          this.load5m = res.data.load5m;
          this.load15m = res.data.load15m;
          this.networkRate = res.data.networkRate;
          this.networkinRate = res.data.networkinRate;
          this.networkoutRate = res.data.networkoutRate;
          this.xaxisData = res.data.xaxisData;
          this.xaxisDataShort = res.data.xaxisDataShort;
          this.allALY();
        });
    },
    // Azure折线图
    checkAzureVmIndex: function() {
      this.$api.cloudWatch
        .checkAzureVmIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region
        })
        .then(res => {
          // Azure
          this.azureTimeline = res.data.azureTimeline;
          this.azureMemoryAndStorageXAxes = res.data.azureMemoryAndStorageXAxes;
          this.azureCpuUsage = res.data.azureCpuUsage;
          this.azureNetworkIn = res.data.azureNetworkIn;
          this.azureNetworkOut = res.data.azureNetworkOut;
          this.azureMemoryPercent = res.data.azureMemoryPercent;
          this.azureStoragePercent = res.data.azureStoragePercent;
          this.allAzure();
        });
    },
    // Vmware折线图
    checkVmwareMonitorModuleIndex: function() {
      this.$api.cloudWatch
        .checkVmwareMonitorModuleIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          instanceId: this.$route.query.instanceId
        })
        .then(res => {
          // Vmware
          // x轴
          this.vmWareTimeline = res.data.vmWareTimeline;
          // 磁盘空间使用率
          this.vmWareDiskSpaceUsage = res.data.vmWareDiskSpaceUsage;
          // 内存使用率
          this.vmWareMemoryUsage = res.data.vmWareMemoryUsage;
          // CPU使用率
          this.vmWareCpuUsage = res.data.vmWareCpuUsage;
          this.allVmware();
        });
    },
    // GCP折线图
    checkGcpVmIndex: function() {
      this.$api.cloudWatch
        .checkGcpVmIndex({
          accountId: this.$route.query.accountId,
          instanceId: this.$route.query.instanceId,
          monitorModule: 0,
          timeHorizon: this.timeType,
          period: this.cycle
        })
        .then(res => {
          // GCP
          this.gcpCpuUsage = res.data.cpuUtilizations;
          this.gcpMemoryPercent = res.data.ramUsed;
          this.gcpTimeline = res.data.xaxisData;
          this.upTime = res.data.upTime;
          this.systemUpTime = res.data.systemUpTime;
          this.gcpNetworkIn = res.data.receivedBytes;
          this.gcpNetworkOut = res.data.sentBytes;
          this.cpuUsageTime = res.data.cpuUsageTime;
          this.diskWriteBytesCount = res.data.diskWriteBytesCount;
          this.diskReadBytesCount = res.data.diskReadBytesCount;
          this.diskMaxWriteOpsCount = res.data.diskMaxWriteOpsCount;
          this.diskMaxReadOpsCount = res.data.diskMaxReadOpsCount;
          this.diskReadOpsCount = res.data.diskReadOpsCount;
          this.diskPercentUsed = res.data.diskPercentUsed;
          this.allGCP();
        });
    },
    // 切换AWS时间
    changeTimeType: function() {
      this.checkMonitorModuleIndex();
    },
    // 切换AWS周期
    changeCycle: function() {
      this.checkMonitorModuleIndex();
    },
    changeTimeTypeALY: function() {
      this.checkALIECSIndex();
    },
    changeTimeTypeAzure: function() {
      this.checkAzureVmIndex();
    },
    changeTimeTypeVmware: function() {
      this.checkVmwareMonitorModuleIndex();
    },
    // 切换GCP时间
    changeTimeTypeGCP: function() {
      this.checkGcpVmIndex();
    },
    // 切换GCP周期
    changeCycleGCP: function() {
      this.checkGcpVmIndex();
    },
    /******************所有折线图********************************/
    init: function() {
      this.cpusLine();
      this.chartDiskReadAndWriteLine();
      this.chartDiskReadAndWriteOperationsLine();
      this.chartNetworkInputAndOutputLine();
      this.chartNetworkPacketIncomingAndOutgoingLine();
      this.chartStatusCheckFailedRandomlyLine();
      this.chartStatusCheckFailedInstanceLine();
      this.chartStatusCheckFailureSystemLine();
      this.chartCpuQuotaUsageLine();
      this.chartCpuQuotaBalanceLine();
      this.memoryUtilizationLine();
      this.cpudiskSpaceUtilizationLine();
      this.linuxInodeUsageLine();
    },
    allALY: function() {
      this.cpuUtilizationLine();
      this.chartDiskSpaceUtilizationLine();
      this.memoryUtilizationALYsLine();
      this.chartNetworkIncomingBandwidthLine();
      this.chartNetworkOutboundBandwidthLine();
      this.chartDiskAverageBPSLine();
      this.chartDiskAverageIOPSLine();
      this.chartVpcPublicIpInternetOutRatePercentLine();
      this.chartCpuTotalLine();
      this.chartNetWorkPackageLine();
      this.chartTcpConnectionLine();
      this.chartAverageSystemLoadLine();
      this.chartNetworkRateLine();
    },
    allAzure: function() {
      this.cpuUtilizationLineAzure();
      this.memoryUtilizationLineAzure();
      this.chartDiskSpaceUtilizationLineAzure();
      this.chartNetworkInputAndOutputsLineAzure();
    },
    allVmware: function() {
      this.cpuUtilizationLineVmware();
      this.memoryUtilizationLineVmware();
      this.chartDiskSpaceUtilizationLineVmware();
    },
    allGCP: function() {
      this.cpuUtilizationLineGCP();
      this.upTimeLineGCP();
      this.systemUpTimeLineGCP();
      this.memoryUtilizationLineGCP();
      this.networkInputAndOutputsLineGCP();
      this.cpuUsageTimeLineGCP();
      this.diskReadBytesCountLineGCP();
      this.diskWriteBytesCountLineGCP();
      this.diskMaxWriteOpsCountLineGCP();
      this.diskMaxReadOpsCountLineGCP();
      this.diskReadOpsCountLineGCP();
      this.diskPercentUsedLineGCP();
    },
    /*************AWS折线图*****************************/
    // CPU利用率 (百分比)
    cpusLine: function() {
      this.chart = this.$echarts.init(this.$refs.cpus[0]);
      this.cpusOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.cpuUtilizations,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chart.setOption(this.cpusOption);
    },
    // 内存使用率 (百分比)
    memoryUtilizationLine: function() {
      this.chartMemoryUtilization = this.$echarts.init(
        this.$refs.memoryUtilizations[0]
      );
      this.memoryUtilizationsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.memoryUtilization,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartMemoryUtilization.setOption(this.memoryUtilizationsOption);
    },
    // 磁盘利用率 (百分比)
    cpudiskSpaceUtilizationLine: function() {
      this.chartCpudiskSpaceUtilization = this.$echarts.init(
        this.$refs.cpudiskSpaceUtilizations[0]
      );
      this.cpudiskSpaceUtilizationsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "10px",
          data: this.cpudiskSpaceUtilizationList
        },
        series: this.cpudiskSpaceUtilization,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpudiskSpaceUtilization.setOption(
        this.cpudiskSpaceUtilizationsOption
      );
    },
    // Linux Inode 利用率 (百分比)
    linuxInodeUsageLine: function() {
      this.chartLinuxInodeUtilization = this.$echarts.init(
        this.$refs.linuxInodeUtilizations[0]
      );
      this.linuxInodeUtilizationsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "10px",
          data: this.linuxInodeUtilizationList
        },
        series: this.linuxInodeUtilization,
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.linuxInodeXaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartLinuxInodeUtilization.setOption(
        this.linuxInodeUtilizationsOption
      );
    },
    // 磁盘读写 (字节)
    chartDiskReadAndWriteLine: function() {
      this.chartDiskReadAndWrite = this.$echarts.init(
        this.$refs.DiskReadAndWrite[0]
      );
      this.DiskReadAndWriteOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读 磁盘写
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.DiskRead"),
            this.$t("alarms.instance.line.DiskWrite")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskRead"),
            type: "line",
            data: this.diskReadBytes,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.DiskWrite"),
            type: "line",
            data: this.diskWriteBytes,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskReadAndWrite.setOption(this.DiskReadAndWriteOption);
    },
    // 读写磁盘操作 (操作)
    chartDiskReadAndWriteOperationsLine: function() {
      this.chartDiskReadAndWriteOperations = this.$echarts.init(
        this.$refs.DiskReadAndWriteOperations[0]
      );
      this.DiskReadAndWriteOperationsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读操作 磁盘写操作
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.DiskReadOperation"),
            this.$t("alarms.instance.line.DiskWriteOperation")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskReadOperation"),
            type: "line",
            data: this.diskReadOps,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.DiskWriteOperation"),
            type: "line",
            data: this.diskWriteOps,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskReadAndWriteOperations.setOption(
        this.DiskReadAndWriteOperationsOption
      );
    },
    // 网络输入输出 (字节)
    chartNetworkInputAndOutputLine: function() {
      this.chartNetworkInputAndOutput = this.$echarts.init(
        this.$refs.NetworkInputAndOutput[0]
      );
      this.NetworkInputAndOutputOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络输入 网络输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkInput"),
            this.$t("alarms.instance.line.NetworkOutput")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkInput"),
            type: "line",
            data: this.networkInput,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NetworkOutput"),
            type: "line",
            data: this.networkOutput,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkInputAndOutput.setOption(
        this.NetworkInputAndOutputOption
      );
    },
    // 网络数据包传入传出 (数量)
    chartNetworkPacketIncomingAndOutgoingLine: function() {
      this.chartNetworkPacketIncomingAndOutgoing = this.$echarts.init(
        this.$refs.NetworkPacketIncomingAndOutgoing[0]
      );
      this.NetworkPacketIncomingAndOutgoingOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络数据包传入 网络数据包传出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.IncomingNetworkPackets"),
            this.$t("alarms.instance.line.OutgoingNetworkPackets")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.IncomingNetworkPackets"),
            type: "line",
            data: this.networkPacketsIn,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.OutgoingNetworkPackets"),
            type: "line",
            data: this.networkPacketsOut,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkPacketIncomingAndOutgoing.setOption(
        this.NetworkPacketIncomingAndOutgoingOption
      );
    },
    // 状态检查失败(任意)(数量)
    chartStatusCheckFailedRandomlyLine: function() {
      this.chartStatusCheckFailedRandomly = this.$echarts.init(
        this.$refs.StatusCheckFailedRandomly[0]
      );
      this.StatusCheckFailedRandomlyOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 状态检查失败(任意)
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StatusCheckFailedOptional")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StatusCheckFailedOptional"),
            type: "line",
            data: this.statusCheckFailed,
            itemStyle: {
              normal: {
                color: "#bebebe",
                lineStyle: {
                  color: "#bebebe"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartStatusCheckFailedRandomly.setOption(
        this.StatusCheckFailedRandomlyOption
      );
    },
    // 状态检查失败(实例) (数量)
    chartStatusCheckFailedInstanceLine: function() {
      this.chartStatusCheckFailedInstance = this.$echarts.init(
        this.$refs.StatusCheckFailedInstance[0]
      );
      this.StatusCheckFailedInstanceOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 状态检查失败(实例)
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StatusCheckFailedExample")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StatusCheckFailedExample"),
            type: "line",
            data: this.statusCheckFailedInstance,
            itemStyle: {
              normal: {
                color: "#2ec7c9",
                lineStyle: {
                  color: "#2ec7c9"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartStatusCheckFailedInstance.setOption(
        this.StatusCheckFailedInstanceOption
      );
    },
    // 状态检查失败(系统) (数量)
    chartStatusCheckFailureSystemLine: function() {
      this.chartStatusCheckFailureSystem = this.$echarts.init(
        this.$refs.StatusCheckFailureSystem[0]
      );
      this.StatusCheckFailureSystemOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 状态检查失败(系统)
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StatusCheckFailedSystem")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StatusCheckFailedSystem"),
            type: "line",
            data: this.statusCheckFailedSystem,
            itemStyle: {
              normal: {
                color: "#a0a7e6",
                lineStyle: {
                  color: "#a0a7e6"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartStatusCheckFailureSystem.setOption(
        this.StatusCheckFailureSystemOption
      );
    },
    // CPU额度使用 (数量)
    chartCpuQuotaUsageLine: function() {
      this.chartCpuQuotaUsage = this.$echarts.init(this.$refs.CpuQuotaUsage[0]);
      this.CpuQuotaUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU额度使用
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUCreditUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUCreditUsage"),
            type: "line",
            data: this.cpucreditUsage,
            itemStyle: {
              normal: {
                color: "#f58db2",
                lineStyle: {
                  color: "#f58db2"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuQuotaUsage.setOption(this.CpuQuotaUsageOption);
    },
    // CPU额度余额 (数量)
    chartCpuQuotaBalanceLine: function() {
      this.chartCpuQuotaBalance = this.$echarts.init(
        this.$refs.CpuQuotaBalance[0]
      );
      this.CpuQuotaBalanceOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU额度余额
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUQuotaBalance")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUQuotaBalance"),
            type: "line",
            data: this.cpucreditBalance,
            itemStyle: {
              normal: {
                color: "#93b7e3",
                lineStyle: {
                  color: "#93b7e3"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuQuotaBalance.setOption(this.CpuQuotaBalanceOption);
    },
    /*************阿里云折线图*****************************/
    // CPU利用率 (百分比)
    cpuUtilizationLine: function() {
      this.chartCpuUtilization = this.$echarts.init(
        this.$refs.cpuUtilization[0]
      );
      this.cpuUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU利用率
        /*  每条数据的名字 */
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")]
        },
        /* 鼠标点击显示的具体数据 */
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.cpuUtilization,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        /* x轴 */
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        /* y轴 */
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuUtilization.setOption(this.cpuUtilizationOption);
    },
    // 内存使用率 (百分比)
    memoryUtilizationALYsLine: function() {
      this.chartmemoryUtilizationALYs = this.$echarts.init(
        this.$refs.memoryUtilizationALYs[0]
      );
      this.memoryUtilizationALYsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.memoryUtilizationALY,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartmemoryUtilizationALYs.setOption(
        this.memoryUtilizationALYsOption
      );
    },
    // 磁盘空间使用率（百分比）
    chartDiskSpaceUtilizationLine: function() {
      this.chartDiskSpaceUtilization = this.$echarts.init(
        this.$refs.diskSpaceUtilization[0]
      );
      this.diskSpaceUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘空间使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskSpaceUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskSpaceUsage"),
            type: "line",
            data: this.diskSpaceUtilization,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskSpaceUtilization.setOption(this.diskSpaceUtilizationOption);
    },
    //网络流入带宽（bit/s）
    chartNetworkIncomingBandwidthLine: function() {
      this.chartNetworkIncomingBandwidth = this.$echarts.init(
        this.$refs.networkIncomingBandwidth[0]
      );
      this.networkIncomingBandwidthOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 公网流入带宽 私网流入带宽
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.IncomingInternetBandwidth"),
            this.$t("alarms.instance.line.InboundBandwidthFromPrivateNetwork")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.IncomingInternetBandwidth"),
            type: "line",
            data: this.internetInRate,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: this.$t(
              "alarms.instance.line.InboundBandwidthFromPrivateNetwork"
            ),
            type: "line",
            data: this.intranetInRate,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkIncomingBandwidth.setOption(
        this.networkIncomingBandwidthOption
      );
    },
    // 网络流出带宽（bit/s）
    chartNetworkOutboundBandwidthLine: function() {
      this.chartNetworkOutboundBandwidth = this.$echarts.init(
        this.$refs.networkOutboundBandwidth[0]
      );
      this.networkOutboundBandwidthOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 公网流出带宽 私网流出带宽
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.PublicNetworkOutgoingBandwidth"),
            this.$t("alarms.instance.line.PrivateNetworkOutgoingBandwidth")
          ]
        },
        series: [
          {
            name: this.$t(
              "alarms.instance.line.PublicNetworkOutgoingBandwidth"
            ),
            type: "line",
            data: this.internetOutRate,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t(
              "alarms.instance.line.PrivateNetworkOutgoingBandwidth"
            ),
            type: "line",
            data: this.intranetOutRate,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkOutboundBandwidth.setOption(
        this.networkOutboundBandwidthOption
      );
    },
    // 磁盘平均BPS (Bps)
    chartDiskAverageBPSLine: function() {
      this.chartDiskAverageBPS = this.$echarts.init(
        this.$refs.diskAverageBPS[0]
      );
      this.diskAverageBPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘总读BPS 磁盘总写BPS
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.DiskTotalReadBPS"),
            this.$t("alarms.instance.line.DiskTotalWriteBPS")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskTotalReadBPS"),
            type: "line",
            data: this.diskReadBPSNew,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.DiskTotalWriteBPS"),
            type: "line",
            data: this.diskWriteBPSNew,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskAverageBPS.setOption(this.diskAverageBPSOption);
    },
    // 磁盘平均IOPS (次/秒)
    chartDiskAverageIOPSLine: function() {
      this.chartDiskAverageIOPS = this.$echarts.init(
        this.$refs.diskAverageIOPS[0]
      );
      this.diskAverageIOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读IOPS 磁盘写IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.DiskReadIOPS"),
            this.$t("alarms.instance.line.DiskWriteIOPS")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskReadIOPS"),
            type: "line",
            data: this.diskReadIOPS,
            itemStyle: {
              normal: {
                color: "#a0a7e6",
                lineStyle: {
                  color: "#a0a7e6"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.DiskWriteIOPS"),
            type: "line",
            data: this.diskWriteIOPS,
            itemStyle: {
              normal: {
                color: "#f58db2",
                lineStyle: {
                  color: "#f58db2"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskAverageIOPS.setOption(this.diskAverageIOPSOption);
    },

    // 磁盘平均IOPS (次/秒)
    chartVpcPublicIpInternetOutRatePercentLine: function() {
      this.chartVpcPublicIpInternetOutRatePercent = this.$echarts.init(
        this.$refs.vpcPublicIpInternetOutRatePercent[0]
      );
      this.vpcPublicIpInternetOutRatePercentOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读IOPS 磁盘写IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.VpcPublicIpInternetOutRatePercent")
          ]
        },
        series: [
          {
            name: this.$t(
              "alarms.instance.line.VpcPublicIpInternetOutRatePercent"
            ),
            type: "line",
            data: this.vpcPublicIpInternetOutRatePercent,
            itemStyle: {
              normal: {
                color: "#a0a7e6",
                lineStyle: {
                  color: "#a0a7e6"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartVpcPublicIpInternetOutRatePercent.setOption(
        this.vpcPublicIpInternetOutRatePercentOption
      );
    },
    // 当前消耗的总CPU百分比
    chartCpuTotalLine: function() {
      this.chartCpuTotal = this.$echarts.init(this.$refs.cpuTotal[0]);
      this.cpuTotalOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 当前消耗的总CPU(百分比)
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.TotalCPUCurrently")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.TotalCPUCurrently"),
            type: "line",
            data: this.cpuTotal,
            itemStyle: {
              normal: {
                color: "#66FFFF",
                lineStyle: {
                  color: "#66FFFF"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };

      this.chartCpuTotal.setOption(this.cpuTotalOption);
    },
    // 网络流入流出数据包数(pps)
    chartNetWorkPackageLine: function() {
      this.chartNetWorkPackage = this.$echarts.init(
        this.$refs.netWorkPackage[0]
      );
      this.netWorkPackageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络流入 流出数据包数(pps)
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkinPackages"),
            this.$t("alarms.instance.line.NetworkoutPackages")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkinPackages"),
            type: "line",
            data: this.networkinPackages,
            itemStyle: {
              normal: {
                color: "#51A59A",
                lineStyle: {
                  color: "#51A59A"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NetworkoutPackages"),
            type: "line",
            data: this.networkoutPackages,
            itemStyle: {
              normal: {
                color: "#FFA488",
                lineStyle: {
                  color: "#FFA488"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetWorkPackage.setOption(this.netWorkPackageOption);
    },
    // TCP连接数(个)
    chartTcpConnectionLine: function() {
      this.chartTcpConnection = this.$echarts.init(this.$refs.tcpConnection[0]);
      this.tcpConnectionOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        //ESTABLISHED NON_ESTABLISHED TCP_TOTAL
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.ESTABLISHED"),
            this.$t("alarms.instance.line.NON_ESTABLISHED"),
            this.$t("alarms.instance.line.TCP_TOTAL")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.ESTABLISHED"),
            type: "line",
            data: this.tcpConnection.ESTABLISHED,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NON_ESTABLISHED"),
            type: "line",
            data: this.tcpConnection.NON_ESTABLISHED,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.TCP_TOTAL"),
            type: "line",
            data: this.tcpConnection.TCP_TOTAL,
            itemStyle: {
              normal: {
                color: "#FFD1FD",
                lineStyle: {
                  color: "#FFD1FD"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartTcpConnection.setOption(this.tcpConnectionOption);
    },
    //系统平均负载
    chartAverageSystemLoadLine: function() {
      this.chartAverageSystemLoad = this.$echarts.init(
        this.$refs.averageSystemLoad[0]
      );
      this.averageSystemLoadOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        //load1m load5m load15m
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.load1m"),
            this.$t("alarms.instance.line.load5m"),
            this.$t("alarms.instance.line.load15m")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.load1m"),
            type: "line",
            data: this.load1m,
            itemStyle: {
              normal: {
                color: "#FFCCCC",
                lineStyle: {
                  color: "#FFCCCC"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.load5m"),
            type: "line",
            data: this.load5m,
            itemStyle: {
              normal: {
                color: "#BBFF66",
                lineStyle: {
                  color: "#BBFF66"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.load15m"),
            type: "line",
            data: this.load15m,
            itemStyle: {
              normal: {
                color: "#CCCCFF",
                lineStyle: {
                  color: "#CCCCFF"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartAverageSystemLoad.setOption(this.averageSystemLoadOption);
    },
    // 网络输入输出
    chartNetworkRateLine: function() {
      this.chartNetworkRate = this.$echarts.init(this.$refs.networkRate[0]);
      this.netWorkRateOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络输入输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkinRate"),
            this.$t("alarms.instance.line.NetworkoutRate")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkinRate"),
            type: "line",
            data: this.networkinRate,
            itemStyle: {
              normal: {
                color: "#5C8A8F",
                lineStyle: {
                  color: "#5C8A8F"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NetworkoutRate"),
            type: "line",
            data: this.networkoutRate,
            itemStyle: {
              normal: {
                color: "#B3CCF4",
                lineStyle: {
                  color: "#B3CCF4"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkRate.setOption(this.netWorkRateOption);
    },
    /*************Azure折线图*****************************/
    // cpu利用率（百分比）
    cpuUtilizationLineAzure: function() {
      this.chartCpuUtilizationAzure = this.$echarts.init(
        this.$refs.cpuUtilizationAzure[0]
      );
      this.cpuUtilizationAzureOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.azureCpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuUtilizationAzure.setOption(this.cpuUtilizationAzureOption);
    },
    // 内存使用率（百分比）
    memoryUtilizationLineAzure: function() {
      this.chartmemoryUtilizationAzure = this.$echarts.init(
        this.$refs.memoryUtilizationAzure[0]
      );
      this.memoryUtilizationAzureOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.azureMemoryPercent,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureMemoryAndStorageXAxes.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartmemoryUtilizationAzure.setOption(
        this.memoryUtilizationAzureOption
      );
    },
    // 磁盘利用率（百分比）
    chartDiskSpaceUtilizationLineAzure: function() {
      this.chartDiskSpaceUtilizationAzure = this.$echarts.init(
        this.$refs.diskSpaceUtilizationAzure[0]
      );
      this.diskSpaceUtilizationAzureOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskUtilization"),
            type: "line",
            data: this.azureStoragePercent,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureMemoryAndStorageXAxes.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskSpaceUtilizationAzure.setOption(
        this.diskSpaceUtilizationAzureOption
      );
    },
    // 网络输入输出（字节）
    chartNetworkInputAndOutputsLineAzure: function() {
      this.chartNetworkInputAndOutputsAzure = this.$echarts.init(
        this.$refs.networkInputAndOutputsAzure[0]
      );
      this.networkInputAndOutputsAzureOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络输入 网络输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkInput"),
            this.$t("alarms.instance.line.NetworkOutput")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkInput"),
            type: "line",
            data: this.azureNetworkIn,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NetworkOutput"),
            type: "line",
            data: this.azureNetworkOut,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.azureTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkInputAndOutputsAzure.setOption(
        this.networkInputAndOutputsAzureOption
      );
    },
    /*************Vmware折线图*****************************/
    // cpu利用率（百分比）
    cpuUtilizationLineVmware: function() {
      this.chartCpuUtilizationVmware = this.$echarts.init(
        this.$refs.cpuUtilizationVmware[0]
      );
      this.cpuUtilizationVmwareOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.vmWareCpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.vmWareTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuUtilizationVmware.setOption(this.cpuUtilizationVmwareOption);
    },
    // 内存使用率（百分比）
    memoryUtilizationLineVmware: function() {
      this.chartMemoryUtilizationVmware = this.$echarts.init(
        this.$refs.memoryUtilizationVmware[0]
      );
      this.memoryUtilizationVmwareOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.vmWareMemoryUsage,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.vmWareTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartMemoryUtilizationVmware.setOption(
        this.memoryUtilizationVmwareOption
      );
    },
    // 磁盘利用率（百分比）
    chartDiskSpaceUtilizationLineVmware: function() {
      this.chartDiskSpaceUtilizationVmware = this.$echarts.init(
        this.$refs.diskSpaceUtilizationVmware[0]
      );
      this.diskSpaceUtilizationVmwareOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.DiskUtilization"),
            type: "line",
            data: this.vmWareDiskSpaceUsage,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.vmWareTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskSpaceUtilizationVmware.setOption(
        this.diskSpaceUtilizationVmwareOption
      );
    },
    /*************GCP折线图*****************************/
    // cpu利用率（百分比）
    cpuUtilizationLineGCP: function() {
      this.chartCpuUtilizationGCP = this.$echarts.init(
        this.$refs.cpuUtilizationGCP[0]
      );
      this.cpuUtilizationGCPOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.gcpCpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuUtilizationGCP.setOption(this.cpuUtilizationGCPOption);
    },
    // upTime（s）
    upTimeLineGCP: function() {
      this.chartUpTime = this.$echarts.init(this.$refs.upTime[0]);
      this.upTimeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.UpTime")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.UpTime"),
            type: "line",
            data: this.upTime,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartUpTime.setOption(this.upTimeOption);
    },
    // sytemUpTime（h）
    systemUpTimeLineGCP: function() {
      this.chartSystemUpTime = this.$echarts.init(this.$refs.systemUpTime[0]);
      this.systemUpTimeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.SystemUpTime")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.SystemUpTime"),
            type: "line",
            data: this.systemUpTime,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartSystemUpTime.setOption(this.systemUpTimeOption);
    },
    // 内存使用率（百分比）
    memoryUtilizationLineGCP: function() {
      this.chartmemoryUtilizationGCP = this.$echarts.init(
        this.$refs.memoryUtilizationGCP[0]
      );
      this.memoryUtilizationGCPOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.gcpMemoryPercent,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartmemoryUtilizationGCP.setOption(this.memoryUtilizationGCPOption);
    },
    // 网络输入输出（字节）
    networkInputAndOutputsLineGCP: function() {
      this.chartNetworkInputAndOutputsGCP = this.$echarts.init(
        this.$refs.networkInputAndOutputsGCP[0]
      );
      this.networkInputAndOutputsGCPOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 网络输入 网络输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkInput"),
            this.$t("alarms.instance.line.NetworkOutput")
          ]
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkInput"),
            type: "line",
            data: this.gcpNetworkIn,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t("alarms.instance.line.NetworkOutput"),
            type: "line",
            data: this.gcpNetworkOut,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartNetworkInputAndOutputsGCP.setOption(
        this.networkInputAndOutputsGCPOption
      );
    },

    //使用时间
    cpuUsageTimeLineGCP: function() {
      this.chartCpuUsageTime = this.$echarts.init(this.$refs.cpuUsageTime[0]);
      var customSeries = [];
      for (var i = 0; i < this.cpuUsageTime.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.cpuUsageTime[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.cpuUsageTime[i].pointData;
        customSeries.push(seriesA);
      }

      this.cpuUsageTimeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 使用时间
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CpuUsageTime")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartCpuUsageTime.setOption(this.cpuUsageTimeOption);
    },

    //磁盘读取字节数
    diskReadBytesCountLineGCP: function() {
      this.chartDiskReadBytesCount = this.$echarts.init(
        this.$refs.diskReadBytesCount[0]
      );
      var customSeries = [];
      for (var i = 0; i < this.diskReadBytesCount.length; i++) {
        var seriesA = {};
        seriesA.name = this.diskReadBytesCount[i].name;
        console.log(seriesA.name, "111");
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskReadBytesCount[i].pointData;
        customSeries.push(seriesA);
      }
      this.diskReadBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读取字节数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskReadBytesCount")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskReadBytesCount.setOption(this.diskReadBytesCountOption);
    },

    //磁盘写入字节数
    diskWriteBytesCountLineGCP: function() {
      this.chartDiskWriteBytesCount = this.$echarts.init(
        this.$refs.diskWriteBytesCount[0]
      );
      var customSeries = [];
      for (var i = 0; i < this.diskWriteBytesCount.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.diskWriteBytesCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskWriteBytesCount[i].pointData;
        customSeries.push(seriesA);
      }
      this.diskWriteBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读取字节数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskWriteBytesCount")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskWriteBytesCount.setOption(this.diskWriteBytesCountOption);
    },

    //峰值磁盘写入操作
    diskMaxWriteOpsCountLineGCP: function() {
      this.chartDiskMaxWriteOpsCount = this.$echarts.init(
        this.$refs.diskMaxWriteOpsCount[0]
      );
      var customSeries = [];
      for (var i = 0; i < this.diskMaxWriteOpsCount.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.diskMaxWriteOpsCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskMaxWriteOpsCount[i].pointData;
        customSeries.push(seriesA);
      }
      this.diskMaxWriteOpsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 峰值磁盘写入操作
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskMaxWriteOpsCount")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskMaxWriteOpsCount.setOption(this.diskMaxWriteOpsCountOption);
    },
    //峰值磁盘读取操作

    diskMaxReadOpsCountLineGCP: function() {
      this.chartDiskMaxReadOpsCount = this.$echarts.init(
        this.$refs.diskMaxReadOpsCount[0]
      );
      var customSeries = [];
      for (var i = 0; i < this.diskMaxReadOpsCount.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.diskMaxReadOpsCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskMaxReadOpsCount[i].pointData;
        customSeries.push(seriesA);
      }
      this.diskMaxReadOpsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 峰值磁盘读取操作
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskMaxReadOpsCount")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskMaxReadOpsCount.setOption(this.diskMaxReadOpsCountOption);
    },
    //磁盘读取IO操作的计数
    diskReadOpsCountLineGCP: function() {
      this.chartDiskReadOpsCount = this.$echarts.init(
        this.$refs.diskReadOpsCount[0]
      );
      var customSeries = [];
      for (var i = 0; i < this.diskReadOpsCount.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.diskReadOpsCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskReadOpsCount[i].pointData;
        customSeries.push(seriesA);
      }
      this.diskReadOpsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 磁盘读取字节数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.DiskReadOpsCount")]
        },
        series: customSeries,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpTimeline.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartDiskReadOpsCount.setOption(this.diskReadOpsCountOption);
    },

    //磁盘使用率
    diskPercentUsedLineGCP: function() {
      this.chartDiskPercentUsed = this.$echarts.init(
        this.$refs.diskPercentUsed[0]
      );

      var customSeries = [];
      for (var i = 0; i < this.diskPercentUsed.length; i++) {
        var seriesA = {};
        //seriesA.name = this.$t("alarms.instance.line.DiskPercentUsed");
        seriesA.name = this.diskPercentUsed[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#ccc", lineStyle: { color: "#ccc" } }
        };
        seriesA.data = this.diskPercentUsed[i].pointData;
        customSeries.push(seriesA);
        /*  const arr = [];
        this.diskPercentUsed.map((item) => {
          arr.push(item.name);
        });
        console.log(arr, "222");
      }
 */
        this.diskPercentUsedOption = {
          title: [
            {
              text: seriesA.name,
              left: "right"
            }
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985"
              }
            }
          },
          // 磁盘读取字节数
          legend: {
            x: "right",
            y: "10px",
            data: [this.$t("alarms.instance.line.DiskPercentUsed")]
          },
          series: customSeries,
          grid: {
            top: "20%",
            left: "3%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: this.gcpTimeline.map(function(str) {
                return str.replace(" ", "\n");
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: "value"
            }
          ]
        };
        this.chartDiskPercentUsed.setOption(this.diskPercentUsedOption);
      }
    },

    /********************************/
    // 点击返回详情页
    ipAddress: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.privateIp = this.$route.query.privateIp;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: "/monitor/elasticComputeCloudDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.Instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.Instance-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/instance_dashboard/Instance.vue